"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Client_1 = __importDefault(require("./Client"));
class ApiEmployees {
    static getHireConfig(token) {
        let url = `/employees/add/config`;
        return Client_1.default.httpGet(url, token);
    }
    static getHireDropDownData(token, vendor, isPaperClient) {
        let url = `/employees/add/dropdowns?vendor=${vendor}&isPaperClient=${isPaperClient}`;
        return Client_1.default.httpGet(url, token);
    }
    static getHireCostCenters(token) {
        let url = `/employees/add/costcenters`;
        return Client_1.default.httpGet(url, token);
    }
    static getStateTaxParams(token, stateCode) {
        let url = `/employees/add/statetax?stateCode=${stateCode}`;
        return Client_1.default.httpGet(url, token);
    }
    static getRehireData(token, employeeId, vendor) {
        let url = `/employees/rehire/data?employeeId=${employeeId}&vendor=${vendor}`;
        return Client_1.default.httpGet(url, token);
    }
    static addEmployee(token, body) {
        let url = `/employees/add`;
        return Client_1.default.httpPost(url, token, body);
    }
    static rehireEmployee(token, body) {
        let url = `/employees/rehire`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getTerminationDetails(token, employeeId) {
        let url = `/employees/terminate?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static terminateEmployee(token, body) {
        let url = `/employees/terminate`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getEmployeeList(token, locationCode, positionCode) {
        let url = `/employees/list?locationCode=${locationCode}&positionCode=${positionCode}`;
        return Client_1.default.httpGet(url, token);
    }
    static getPrehireList(token, standalone = true) {
        let url = `/employees/list/prehires`;
        if (!standalone)
            url += '?standalone=false';
        return Client_1.default.httpGet(url, token);
    }
    static getApplicantList(token) {
        let url = `/employees/list/applicants`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeLocations(token) {
        let url = `/employees/locations`;
        return Client_1.default.httpGet(url, token);
    }
    static getClientLocationData(token) {
        let url = `/employees/locations/data`;
        return Client_1.default.httpGet(url, token);
    }
    static getLocationDetails(token, code) {
        let url = `/employees/locations/details?code=${code}`;
        return Client_1.default.httpGet(url, token);
    }
    // Returns an empty Ok
    static addLocation(token, body) {
        let url = `/employees/locations`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getEmployeeStatuses(token) {
        let url = `/employees/statuses`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeeDepartments(token) {
        let url = `/employees/departments`;
        return Client_1.default.httpGet(url, token);
    }
    static getGeoCodes(token, zipCode) {
        let url = `/employees/geocodes?zipCode=${zipCode}`;
        return Client_1.default.httpGet(url, token);
    }
    static getEmployeePositions(token) {
        let url = `/employees/positions`;
        return Client_1.default.httpGet(url, token);
    }
    static getClientPositionData(token) {
        let url = `/employees/positions/data`;
        return Client_1.default.httpGet(url, token);
    }
    static getPositionClassifications(token) {
        let url = `/employees/positions/classes`;
        return Client_1.default.httpGet(url, token);
    }
    static getPositionDetails(token, code) {
        let url = `/employees/positions/details?code=${code}`;
        return Client_1.default.httpGet(url, token);
    }
    // Returns an empty Ok
    static addPosition(token, body) {
        let url = `/employees/positions`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getManageDetails(token, employeeId) {
        let url = `/employees/manage?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static getPhoto(token, employeeId) {
        let url = `/employees/photo/get?employeeId=${employeeId}`;
        return Client_1.default.httpGet(url, token);
    }
    static uploadPhoto(token, employeeId, body) {
        let url = `/employees/photo/upload?employeeId=${employeeId}`;
        return Client_1.default.httpPost(url, token, body);
    }
    static getBirthdays(token, startDate, endDate) {
        let url = `/employees/birthdays`;
        const params = [];
        if (startDate) {
            params.push(`startDate=${startDate}`);
        }
        if (endDate) {
            params.push(`endDate=${endDate}`);
        }
        if (params.length > 0) {
            url += `?${params.join('&')}`;
        }
        return Client_1.default.httpGet(url, token);
    }
}
exports.default = ApiEmployees;
